// Generated by ReScript, PLEASE EDIT WITH CARE


let baseRoute = "/cash-register-reports";

export {
  baseRoute,
}
/* No side effect */
